import React from "react"
import close from "./img/close.png"

export default function CerrarVentana({ set }) {
    return (
        <div style={{ textAlign: "right" }}>
            <img src={close} alt="+"
                title="Cerrar"
                height="15px"
                width="15px"
                style={{ cursor: "pointer", margin: " 5px 5px" }}
                onClick={() => {
                    set(false)
                }}
            ></img>
        </div>)
}